module.exports = __webpack_public_path__ + "SG.png?cfb144e2ebb009497a216b77e27ee600";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/SG.png
// module id = 405
// module chunks = 0